import { TransactionDetail } from "@/utils/dataTypes"
import { Stack, Typography } from "@mui/material"
import { FC } from "react"
import Image from "next/image"
import DogCuteSuccess from "@/assets/images/dog-cute-success.png"
import useTrans from "@/hooks/useTrans"
import Button from "@/components/base/Button"

type ModalTxSucceded = {
  transactionDetail: TransactionDetail
  handleCloseModal: () => void
}

const View: FC<ModalTxSucceded> = ({ transactionDetail, handleCloseModal }) => {
  const trans = useTrans()
  const isDisplayingGoHomeButton = transactionDetail.isDisplayingGoHomeButton === true

  return (
    <Stack alignItems='center' gap={1}>
      <Image src={DogCuteSuccess} alt='hero-stat-icon' height={182} style={{ marginBottom: 16 }} />
      <Typography className='text-neutral-1000 text-sm sm:text-base font-semibold text-center'>
        {transactionDetail.title}
      </Typography>
      <Typography className='text-neutral-900 text-sm sm:text-base text-center'>{transactionDetail.content}</Typography>
      <Stack className='w-full' gap={1}>
        {transactionDetail.ctaButtonLink && (
          <Button variant='primary' fullWidth href={transactionDetail.ctaButtonLink}>
            {transactionDetail.ctaButtonTitle ? transactionDetail.ctaButtonTitle : trans.dashboard.modal.view_tx}
          </Button>
        )}
        {isDisplayingGoHomeButton && (
          <Button variant='outlined' fullWidth onClick={handleCloseModal}>
            {trans.dashboard.modal.go_home}
          </Button>
        )}
      </Stack>
    </Stack>
  )
}

export default View
